import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UIService } from '../../../shared/ui.service';
import { inprocess, ProcessRunService } from '../../shared/process-run.service';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [

];


@Component({
  selector: 'app-in-progress-process',
  templateUrl: './in-progress-process.component.html',
  styleUrls: ['./in-progress-process.component.css']
})
export class InProgressProcessComponent implements OnInit {
  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol', 'pstatus'];
  data: inprocess[] = [];
  dataSource = new MatTableDataSource<inprocess>(this.data);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private ps: ProcessRunService, public sh: UIService) { }
  fetchTheProcess() {
    this.ps.getPInrocessRUns().subscribe((r: any) => {
      if (r?.statusCode == 200) {
        this.dataSource.data = r?.custProcessRuns;
      }
    })
  }
  ngOnInit(): void {
    this.ps.fetchInprocess.subscribe((r) => {
      this.fetchTheProcess();
    })
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  dateFormatter(time: string) {
    return this.sh.dateFormatter(time);
  }
  formatAMPMT(time:string) {
    return this.sh.formatAMPMT(time);

  }
}
